import { service } from '@/ajax/request'

export const clientActivityDict = () => (
    service({
        url: '/activityTipsDisposition/readDictDetails',
        method: 'POST',
    })
)

export const activityClientDict = () => (
    service({
        url: '/activityTipsDisposition/readAppDetails',
        method: 'POST',
    })
)

export const saveOrUpdateClientActivity = (params) => (
    service({
        url: '/activityTipsDisposition/saveOrUpdateActivityTips',
        method: 'POST',
        params,
    })
)

export const clientActivityList = (params) => (
    service({
        url: '/activityTipsDisposition/activityTipsList',
        method: 'POST',
        params,
    })
)

export const updateClientActivityStatus = (params) => (
    service({
        url: '/activityTipsDisposition/updateActivityTipsStatus',
        method: 'POST',
        params,
    })
)